/**
 * /devhub/runtime-cockpit — Phase 12 Operations Cockpit surface.
 * REQ-001.91 DevHub UI rebuild · Phase 12 (unified map).
 *
 * Operator-only (routePolicy plane guard + DevHubPanelPage self-guard).
 * Mounts the OperationsCockpitPanel.
 */

import { createFileRoute } from '@tanstack/react-router';
import { OperationsCockpitPanel } from '../features/control-plane/OperationsCockpitPanel';
import { DevHubPanelPage } from '../components/devhub/DevHubPanelPage';

export const Route = createFileRoute('/devhub/runtime-cockpit')({
  component: CockpitPage,
});

function CockpitPage() {
  return (
    <DevHubPanelPage
      title="Operations Cockpit"
      subtitle="Phase 12 — the unified runtime map. One Carbon surface for every Swift module, every inference lane, every ToolGateway route, every worker, every contract, every Apple framework adoption, and every integration. Built from /api/cockpit/*."
      status={{ state: 'polling', label: '12 sections', detail: 'Phase 12' }}
    >
      <OperationsCockpitPanel />
    </DevHubPanelPage>
  );
}
